import type {
  DayCountingMode,
  InvoiceLineConcept,
  InvoiceStatus,
  LocationDisplayStatus,
  LocationStatus,
  MovementType,
  OutboundLineStatus,
  OutboundOrderStatus,
  PalletStatus,
  UserRole,
} from './enums';

/** Textos de interfaz para las enumeraciones de dominio. */

export const USER_ROLE_LABELS: Record<UserRole, string> = {
  ADMIN: 'Administrador',
  OFFICE: 'Administración',
  OPERATOR: 'Operario',
};

export const PALLET_STATUS_LABELS: Record<PalletStatus, string> = {
  PENDING_LOCATION: 'Pendiente de ubicación',
  STORED: 'Almacenado',
  RESERVED: 'Preparando salida',
  EXITED: 'Salido',
  CANCELLED: 'Anulado',
};

export const LOCATION_STATUS_LABELS: Record<LocationStatus, string> = {
  ACTIVE: 'Activa',
  OUT_OF_SERVICE: 'Fuera de servicio',
};

export const LOCATION_DISPLAY_STATUS_LABELS: Record<LocationDisplayStatus, string> = {
  FREE: 'Libre',
  OCCUPIED: 'Ocupada',
  RESERVED: 'Ocupada · preparando salida',
  OUT_OF_SERVICE: 'Fuera de servicio',
};

export const MOVEMENT_TYPE_LABELS: Record<MovementType, string> = {
  PLACEMENT: 'Ubicación inicial',
  RELOCATION: 'Movimiento',
  RELEASE: 'Liberación por salida',
};

export const OUTBOUND_ORDER_STATUS_LABELS: Record<OutboundOrderStatus, string> = {
  OPEN: 'En preparación',
  COMPLETED: 'Completada',
  CANCELLED: 'Cancelada',
};

export const OUTBOUND_LINE_STATUS_LABELS: Record<OutboundLineStatus, string> = {
  PENDING: 'Pendiente',
  PICKED: 'Recogido',
  SHIPPED: 'Salido',
  REMOVED: 'Retirado de la orden',
};

export const INVOICE_STATUS_LABELS: Record<InvoiceStatus, string> = {
  DRAFT: 'Borrador',
  ISSUED: 'Emitida',
  PAID: 'Cobrada',
  CANCELLED: 'Anulada',
};

export const INVOICE_LINE_CONCEPT_LABELS: Record<InvoiceLineConcept, string> = {
  ENTRY: 'Entrada',
  STORAGE: 'Almacenaje',
  EXIT: 'Salida',
};

export const DAY_COUNTING_MODE_LABELS: Record<DayCountingMode, string> = {
  CALENDAR_DAYS: 'Días naturales',
  STARTED_24H_PERIODS: 'Periodos de 24 h iniciados',
};
